export const xviCellRendererComponents = [];

export const xviCellEditorComponents = [];

export const xviFrameworkComponents = [
  ...xviCellEditorComponents,
  ...xviCellRendererComponents,
];
